import { Colors } from '@/common/colors/colors';
import styled from 'styled-components';

export const OldTicketsWrapper = styled.div`
	grid-column: 1 / 2;
	grid-row: 5 / 7;
	background-color: ${Colors.lightGray};
	position: relative;
	overflow: scroll;
	overflow-x: hidden;
	&::-webkit-scrollbar {
		display: none;
	}
`;

export const OldMessageSender = styled.p`
	display: flex;
	justify-content: 2px;
	font-size: 14px;
	align-items: center;
	gap: 2px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	font-weight: bold;
`;

export const OldMessageInfoWrapper = styled.div`
	width: 50%;
	padding: 0 24px;
`;

export const OldMessageStatus = styled.div`
	text-align: center;
	font-size: 14px;
	padding: 4px 10px;
	color: white;
	font-weight: bold;
	border-radius: 10px;
	background-color: ${(props) => props.bgColor};
`;

export const OldMessageText = styled.p`
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	font-size: 12px;
`;

export const OldMessageItem = styled.div`
	padding: 8px;
	background-color: ${(props) => props.backgroundColor};
	cursor: pointer;
	color: ${(props) => props.color};
	display: flex;
	align-items: center;
	gap: 12px;
	border-bottom: 1px solid ${Colors.newLightColor};
`;

export const OnlineRound = styled.span`
	background-color: ${(props) => props.backgroundColor};
	width: 10px;
	height: 10px;
	border-radius: 50%;
`;

export const PriorityWrapper = styled.div`
	position: absolute;
	transform: translate(calc(-100% - 4px), 4px);
	background-color: ${Colors.red};
	border-radius: 50%;
	width: 14px;
	height: 14px;
	display: flex;
	justify-content: center;
	align-items: center;
`;
